import { Component, OnInit } from '@angular/core';
import { AuthService } from './services/auth.service';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: true,
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit{
  title = 'totalcash-front';

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.authService.checkInitialTokenValidity();
  }
}